module.exports = __webpack_public_path__ + "static/media/Zen.d9ff9442.webp";